import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import AppSidebar from '../components/AppSidebar';
import WtiLoader from '../components/WtiLoader';
import { trainingService } from '../services/trainingService';
import toast from 'react-hot-toast';
import '../App.css';

const Training: React.FC = () => {
  const [skoolUrl, setSkoolUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const info = await trainingService.getSkoolCommunityInfo();
        setSkoolUrl(info.skoolCommunityUrl || null);
      } catch {
        toast.error('Failed to load training page');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const openSkool = () => {
    if (!skoolUrl) return;
    window.open(skoolUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="wti-shell">
      <AppSidebar />

      <div className="wti-main">
        <div className="container dashboard-page">
          <header className="dashboard-header">
            <div className="dashboard-title-block">
              <h1>Training</h1>
              <p className="dashboard-subtitle">
                Access WTI training and community resources on Skool.
              </p>
            </div>
          </header>

          {loading ? (
            <WtiLoader message="Loading training…" />
          ) : skoolUrl ? (
            <section className="dashboard-skool-card card" aria-label="Skool Community">
              <div className="dashboard-skool-card__content">
                <div className="dashboard-skool-card__icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faUsers} />
                </div>
                <div className="dashboard-skool-card__text">
                  <h2>Skool Community</h2>
                  <p>Join the WTI community on Skool.</p>
                  <p className="dashboard-skool-card__hint">
                    Open Skool Community in a new tab
                  </p>
                  <a
                    href={skoolUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="training-skool-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {skoolUrl}
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                  </a>
                </div>
                <button
                  type="button"
                  className="btn btn-primary dashboard-skool-card__button"
                  onClick={openSkool}
                >
                  Open Skool Community
                </button>
              </div>
            </section>
          ) : (
            <div className="card training-empty-card">
              <p>Skool community link is not available right now.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Training;
